import React, { Component } from "react";
import PropTypes from "prop-types";
import { Div } from "glamorous";
import Header from "./common/Header";
import Spinner from "./common/Spinner";
import Canvasses from "./common/Canvasses";
import Areas from "./areas";
import handlers from "./handlers";
import {
  setArea,
  setAreaFromHash,
  handleBack,
  setLoading,
  setLabel
} from "../actions/app";
import { handleAddToBasket } from "../misc/router";
import { generate, generateFramed } from "../actions/generate";
import { post } from "../misc/api";
import validate from "../misc/validate";
import { track, setCookieItem } from "../misc/utils";
import data from "../data";
import initialState from "../misc/initial-state";
import styles from "../styles";
import { ExperienceProvider } from '../providers/ExperienceContext';

class App extends Component {
  constructor() {
    super();
    this.state = initialState.all();
  }

  goToArea(area) {
    console.log("tracking page: " + area);
    track.page(area);
    this.setState(setArea(area));
  }

  isShowingStartPage() {
    const context = this.getExperienceState();
    if (context.isInStore) {
      return this.state.area !== 'ProductSelector';
    }
    return this.state.area !== 'Landing';
  }

  componentWillMount() {
    data.setLocale(this.props.locale || "en");

    window.appMethod = this.props.method; // TODO: bad global!
    this.url = document.referrer;

    this.setState({productId: this.props.productId});

    let validated = validate.params(this.props);
    if (validated.error) {
      this.setState({error: validated.error});
      this.setState(this.goToArea('Error'));
    } else {
      this.setState(this.goToArea(initialState.all(this.props).area));

      if (this.props.method !== "script") {
        window.onhashchange = () => this.setState(setAreaFromHash);
      }
    }
    this.cookieShowOrHide();
  }
  
  cookieShowOrHide(){
    const {cookieStatus} =  this.props;
    if (cookieStatus !== "noCookie") {
      document.body.classList.remove("no-cookie-banner");
    } else {
      this.deleteCookiePopup();
    }
  }
  
 deleteCookiePopup () {
		document.body.classList.add("no-cookie-banner");
		const timeElapsed = Date.now();
		const today = new Date(timeElapsed);
		const formatTime = today.toISOString();
		setCookieItem("OptanonAlertBoxClosed", formatTime);
	};

  getExperienceState() {
    return {
      isInStore: this.props.productId === undefined || (this.props.journey && this.props.productId && !this.props.token),
      isEmbedded: this.props.method === "script",
      method: this.props.method || (this.props.productId ? 'redirect' : 'script')
    }
  }

  resetLabel() {
    // this.setTemplate(this.state.template);
    track.event("button", "click", "Exit");
    const area = this.props.productId === undefined ? 'ProductSelector' : 'Landing';
    this.goToArea(area);
  }

  resetText() {
    const { label, template } = this.state;
    label.text = [ ...template.text ];
    this.setState({label});
  }

  setTemplate(template) {
    this.setState({
      label: {
        background: template.background,
        isFixed: template.isFixed,
        text: [...template.text ],
        renderedLabel: null
      },
      template
    });

    this.goToArea(template.isFixed ? 'EditorTemplate' : 'EditorSimple');
  }

  setRenderedLabel(renderedLabel) {
    let label = this.state.label;
    label.renderedLabel = renderedLabel;
    this.setState({label});
  }

  useFilteredImage(image, filterName) {
    let label = this.state.label;
    label.background = image || this.state.template.background;
    this.setState({label, filterName});
  }

  onImageUpload(image) {
    const template = {
      background: image,
      isFixed: false,
      text: []
    };
    this.setTemplate(template);
  }

  render() {
    const context = this.getExperienceState();
    return (
      <ExperienceProvider value={context}>
        <Div css={styles.app.main(this.state.area, context.method, this.state.productId)}>
          <Div css={styles.app.content(this.state.area)}>
            {this.renderHeader(context)}
            {this.state.loading ? (
              <Spinner message={this.state.loading} />
            ) : (
              this.renderArea()
            )}
          </Div>
          {this.renderFooter()}
          <Canvasses />
        </Div>
      </ExperienceProvider>
    );
  }

  renderHeader(context) {
    return (
      <Header
        showBackButton={this.isShowingStartPage()}
        handleBack={() => {
          this.setState(handleBack);
        }}
        handlePlay={() => {
          track.event("Video", "Play", "Video_see_how_it_works");
          this.goToArea('TutorialVideo')
        }}
        handleLogoClick={() => {
          track.event("button", "click", "Exit");
          const area = context.isInStore ? 'ProductSelector' : 'Landing';
          this.goToArea(area);
        }}
        referrer={this.url}
        area={this.state.area}
        loadProductSelectorArea={() => this.goToArea('ProductSelector')}
        resetLabel={this.resetLabel.bind(this)}
      />
    );
  }

  renderArea() {
    const CurrentArea = Areas[this.state.area];
    return (
      <CurrentArea
        {...{
          handlePreviewMyBottle: this.generateLabel.bind(this),
          handleAddToBasket: () => handleAddToBasket(this.props, this.state),
          ...handlers(this),
          setArea: this.goToArea.bind(this),
          setTemplate: this.setTemplate.bind(this),
          onImageUpload: this.onImageUpload.bind(this),
          resetLabel: this.resetLabel.bind(this),
          resetText: this.resetText.bind(this),
          useFilteredImage: this.useFilteredImage.bind(this),
          ...this.props,
          ...this.state,
        }}
      />
    );
  }

  renderFooter() {
    const {pageStatus} =  this.props;
    if(pageStatus&&pageStatus==='noFooter'){
      return <div></div>
    }
    return (<div id="footer"></div>);
  }

  async generateLabel(refWidth, refHeight) {
    track.event("button", "click", "editor_continue");
    this.setState(setLoading(data.copy("savingLabel")));

    const { label, productId } = this.state;

    try {
      const { src, labelId } = await generate({
        refWidth,
        refHeight,
        label
      });

      this.setRenderedLabel(src);

      const framedSrc = await generateFramed(src);

      const postRes = await post("generate", {
        src: framedSrc,
        labelId,
        productId,
        ...this.props
      });

      this.setState(setLabel({ labelId, labelUrl: postRes.labelUrl }));

      this.setState(setLoading(false));
      this.goToArea('PreviewLabel');

      if (!postRes.complete) {
        throw new Error("Error saving label");
      }
    } catch (err) {
      this.setState(setLoading(false));
      console.log(err);
      alert(err);
    }
  }
}

App.propTypes = {
  method: PropTypes.oneOf(["script", "redirect"]),
  journey: PropTypes.oneOf(["instore", "instoreba", "retailer"]),
  brandId: PropTypes.string,
  productId: PropTypes.string,
  callbackUrl: PropTypes.string,
  price: PropTypes.string, // a string instead of a number avoids formatting issues (, .)
  locale: PropTypes.string,
  currencyId: PropTypes.string,
  custom: PropTypes.object.isRequired
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js